import styled from 'styled-components';

export const Container = styled.div`
  .highlight-today {
    background-color: #adb5bd !important;
    border-radius: 20%;
  }

  .legend {
    display: flex;
    margin-top: 10px;
  }

  .legend-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    margin-right: 5px;
  }

  .react-calendar {
    border: none;
    width: 100%;
    font-size: 16px;
  }

  .react-calendar__tile {
    height: 50px;
    position: relative;

    &:hover {
      border-radius: 20%;
    }
  }

  .react-calendar__tile--active {
    background-color: #6c757d !important;
    color: white !important;
    border-radius: 20%;
  }

  .weekend {
    color: #aaa;
  }
`;
